import { LoadingService } from './../../../services/loading.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { InnerHtmlDialogComponent } from 'src/app/dialog/inner-html-dialog/inner-html-dialog.component';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeOp, page } from 'src/app/util/animations.util';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css'],
  animations: [
    fadeOp,
    page
  ]
})
export class UnauthorizedComponent implements OnInit, OnDestroy {

  privacy!: SafeHtml;
  currentLang!: string;
  availableLang!: string[];
  contactUsContent!: SafeHtml;


  languages = [
    { code: 'en' },
    { code: 'ch' },
    { code: 'jp' },
    { code: 'kr' },
  ];
  privacy_policy = {
    title: "PRIVACY.TITLE",
    main_p: [
      "PRIVACY.MAIN_P.P_ONE",
      "PRIVACY.MAIN_P.P_TWO"
    ],
    content: [
      {
        title: "PRIVACY.CONTENT.TITLE.ONE",
        p: [
          "PRIVACY.CONTENT.POINT_ONE.ONE",
          "PRIVACY.CONTENT.POINT_ONE.TWO"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.TWO",
        desc: "PRIVACY.CONTENT.POINT_TWO.DESC",
        p: [
          "PRIVACY.CONTENT.POINT_TWO.ONE",
          "PRIVACY.CONTENT.POINT_TWO.TWO",
          "PRIVACY.CONTENT.POINT_TWO.THREE",
          "PRIVACY.CONTENT.POINT_TWO.FOUR",
          "PRIVACY.CONTENT.POINT_TWO.FIVE"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.THREE",
        p: [
          "PRIVACY.CONTENT.POINT_THREE.ONE"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.FOUR",
        p: [
          "PRIVACY.CONTENT.POINT_FOUR.ONE",
          "PRIVACY.CONTENT.POINT_FOUR.TWO"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.FIVE",
        p: [
          "PRIVACY.CONTENT.POINT_FIVE.ONE"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.SIX",
        p: [
          "PRIVACY.CONTENT.POINT_SIX.ONE",
          "PRIVACY.CONTENT.POINT_SIX.TWO"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.SEVEN",
        p: [
          "PRIVACY.CONTENT.POINT_SEVEN.ONE"
        ]
      },
      {
        title: "PRIVACY.CONTENT.TITLE.EIGHT",
        p: [
          "PRIVACY.CONTENT.POINT_EIGHT.ONE"
        ]
      }
    ]
  };

  @ViewChild("manualDialog") ManualDialog!: TemplateRef<any>;
  private destroy$ = new Subject<void>();

  constructor(
    private utility: UtilityService,
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
    private loadingService: LoadingService,
    private translate: TranslateService,
    private http: HttpClient,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.currentLang = this.safeGetLang();
    this.availableLang = this.utility.getAvailableLang();
    this.loadingService._clearLoading();
  }

  get availableLangs(): string[] {
    return this.utility.getAvailableLang();
  }

  private safeGetLang(): string {
    try {
      return this.utility.getLang() || 'en';
    } catch (e) {
      console.warn('localStorage not accessible, fallback to en', e);
      return 'en';
    }
  }

  changeLang(language: { code: string }): void {
    this.setLang(language.code);
    try {
      this.localStorageService.set(LocalStorage.LANG, language.code);
    } catch (e) {
      console.warn('localStorage not accessible, language change not persisted', e);
    }
  }

  private setLang(lang: string): void {
    this.utility.setLang(lang);
    this.currentLang = lang;
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (typeof window !== 'undefined') {
      localStorage.removeItem('reset-password-email');
    }
  }

  openPrivacyDialog(): void {
    this.http.get(environment.API_URL + 'privacy', { responseType: 'text' })
      .subscribe(
        response => {
          this.dialog.open(InnerHtmlDialogComponent, {
            width: '950px',
            data: {
              isContact: false,
              privacy: this.privacy_policy
            }
          });
        }
      )
  }

  onOpenManual() {
    this.dialog.open(this.ManualDialog, {
      autoFocus: false,
      disableClose: true,
      width: '1080px',
    });
  }

  onDownloadManual() {
    // @ts-ignore
    this.http.get<Blob>("/assets/img/Online-Ticket-Manual.png", { responseType: 'arraybuffer' })
      .subscribe(response => {
        const url = URL.createObjectURL(new Blob([response], { type: 'image/png' }));
        const a = document.createElement('a');
        a.href = url;
        a.download = "Online-Ticket-Manual.png";
        a.click();
        URL.revokeObjectURL(url);
      })
  }

  getContactUrl(): void {
    this.apiService.getContactUsContent()
      .subscribe(
        response => {
          let data = response.data;
          this.contactUsContent = this.sanitizer.bypassSecurityTrustHtml(data.email);
          this.dialog.open(InnerHtmlDialogComponent, {
            width: '1000px',
            disableClose: true,
            autoFocus: false,
            data: {
              contact: response.data,
              isContact: true
            }
          });
        }
      )
  }

  openContact(): void {
    window.open("https://www.angkorenterprise.gov.kh/contact", "_blank");
  }

  _googlePlay(): void {
    window.open("https://play.google.com/store/apps/details?id=com.angkor_pass.app", "_blank");
  }

  _appStore(): void {
    window.open("https://apps.apple.com/us/app/angkor-pass/id6698859997", "_blank");
  }
}
